import { Descriptions } from "antd";
import React from "react";

const LABEL_WIDTH = 220;

type Props = {
  items: { label: string; children: React.ReactNode }[];
};

export const ContractClientsData = ({ items }: Props) => {
  return (
    <Descriptions
      size="small"
      styles={{ label: { minWidth: LABEL_WIDTH }, content: { minWidth: 0, maxWidth: 0, width: "100%" } }}
      bordered
      column={1}
      items={items}
    />
  );
};
